__turbopack_context__.v({
  "limitedHeight": "Services-module-scss-module__l_YS0q__limitedHeight",
  "normalHeight": "Services-module-scss-module__l_YS0q__normalHeight",
  "servicesContainer": "Services-module-scss-module__l_YS0q__servicesContainer",
  "tag": "Services-module-scss-module__l_YS0q__tag",
});
